module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 10.44145d78.png";